import { useEffect } from 'react';

type TExternalRedirectProps = {
  to: string;
};

const ExternalRedirect = ({ to }: TExternalRedirectProps) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return null;
};

export default ExternalRedirect;
